import type {ReactElement} from 'react';
import React from 'react';
import {Option} from '@Components/contextual-menu/components/option';
import {TextWithInfo} from '@Components/contextual-menu/components/text-with-info';

interface ContextualMenuTextWithInfoOptionProps {
  id: string;
  label: string;
  className?: string;
  text: string;
  subText: string;
  infoContainerClassName?: string;

  onClick(): void;
}

export function ContextualMenuTextWithInfoOption({className = '', ...props}: ContextualMenuTextWithInfoOptionProps): ReactElement<any> | null {
  return (
    <Option
      key={props.id}
      className={className}
      label={props.label}
      optionControl={
        <TextWithInfo
          className={props.infoContainerClassName}
          text={props.text}
          subText={props.subText}
          onClick={(): void => {
            props.onClick();
          }}
        />
      }
    />
  );
}
